import { Injectable, inject } from '@angular/core';
import { HttpService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  private http = inject(HttpService);

  importXerFile(entityInstanceId: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const params = this.http.buildHttpParams({ entityInstanceId });
    return this.http.put('_api/Projects/ImportXerFile', formData, {
      httpOptions: { params },
      useLoader: false,
    });
  }

  importMSProjectFile(entityInstanceId: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    const params = this.http.buildHttpParams({ entityInstanceId });
    return this.http.put('_api/Projects/ImportMSProjectFile', formData, {
      httpOptions: { params },
      useLoader: false,
    });
  }
}
